<template>
  <div>
    <div class="row">
      <div class="col-md-7 col-sm-12">
        <TitleBreadcrumb :page="page" />
      </div>
      <div
        class="col-md-5 col-sm-12 col-md-12 col-lg-5 col-xl-5 d-flex justify-content-end"
      >
        <div>
          <div class="d-flex">
            <div class="mx-1">
              <ActionButton
                id="btnRegistryGoBack"
                variant="outline-success"
                i="fas fa-arrow-circle-left"
                @click="goBack()"
              >
                Regresar
              </ActionButton>
            </div>
            <div
              v-if="
                page.tabIndex === 5 &&
                  isInCoordinatedAppointment &&
                  canEditTab[page.tabIndex]
              "
              class="mx-1"
            >
              <ActionButton
                id="btnRegistryAdd"
                variant="outline-success"
                i="fas fa-file-plus"
                @click="goToAddAppointment()"
              >
                Añadir
              </ActionButton>
            </div>
            <div
              v-if="
                page.tabIndex === 1 &&
                  isPreRegistred &&
                  canEditTab[page.tabIndex]
              "
              class="mx-1"
            >
              <ActionButton
                id="btnRegistryRegister"
                variant="outline-success"
                i="fas fa-file-import"
                @click="onRegister()"
              >
                Registrar
              </ActionButton>
            </div>
            <div v-if="canCreateReferral" class="mx-1">
              <ActionButton
                id="btnRegistrySave"
                variant="success"
                type="submit"
                i="fas fa-file-plus"
                @click="createNewReferral"
              >
                Crear Referido
              </ActionButton>
            </div>
            <div v-if="canSave" class="mx-1">
              <ActionButton
                id="btnRegistrySave"
                variant="success"
                type="submit"
                i="fas fa-save"
                :hidden="saveButtonVisibility || !canEditTab[page.tabIndex]"
                @click="save()"
              >
                Guardar
              </ActionButton>
            </div>
            <div v-if="canChangeInitialEvaluationFlag" class="mx-1">
              <ActionButton
                variant="outline-success"
                i="fas fa-reply-all"
                @click="onChangeInitialEvaluationFlag()"
              >
                Cambiar Pregunta de Evaluación
              </ActionButton>
            </div>
            <div v-if="showReports" class="mx-1">
              <drop-down
                :title="{
                  name: 'informes',
                  icon: 'fas fa-file-alt',
                  color: 'text-green',
                }"
                :items="reportActions"
                @ee05="downloadEE05"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-divider mt-2 pb-2 w-100" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapMutations } = createNamespacedHelpers('$_student');
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import ActionButton from '@/components/common/ActionButton';
import DropDown from '@/components/common/menu/DropDown';
import StudentStatuses from '@/utils/constants/student/studentStatuses';
import store from '@/store/index';
import reportService from '@/services/report';

export default {
  props: {
    buttonsave: {
      type: Boolean,
      default: true,
    },
    page: {
      type: Object,
      required: true,
    },
    student: {
      type: Object,
      default: () => ({}),
    },
    showCreateNewReferralOption: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    TitleBreadcrumb,
    ActionButton,
    DropDown,
  },
  data() {
    return {
      reportActions: [
        {
          Title: 'Formulario EE-05',
          Icon: 'fas fa-print',
          IconColor: 'text-green',
          EmitGo: 'ee05',
          Item: 1,
          Type: 'Menu',
          Visible: true,
          Children: [],
        },
      ],
      canEditTab: [
        false,
        store.getters.HasPermission('registry.editTab1'),
        store.getters.HasPermission('registry.editTab2'),
        store.getters.HasPermission('registry.editTab3'),
        store.getters.HasPermission('registry.editTab4'),
        store.getters.HasPermission('registry.editTab5'),
        store.getters.HasPermission('registry.editTab6'),
        true,
      ],
    };
  },
  methods: {
    ...mapMutations([
      'setStudentPreRegistryValidations',
      'setRegisterSavePropagation',
    ]),
    async downloadEE05() {
      let isInitial = !this.student.isPostRegistry ? 1 : 0;
      let regStudentId = this.$store.state.$_student.selectedStudent
        .regStudentId;
      let regStudentPostRegistryId = this.studentPreRegistry
        ?.regStudentPostRegistryId;

      await reportService.downloadEE05(
        regStudentId,
        isInitial,
        regStudentPostRegistryId
      );
    },
    save() {
      this.$store.dispatch('saveChangesOnForm');
    },
    createNewReferral() {
      this.$emit('create-new-referral');
    },
    goBack() {
      this.$router.push('/student/registryhistory');
    },
    onRegister() {
      this.$store.dispatch('registerStudent');
      this.setRegisterSavePropagation({
        value: true,
        date: new Date(),
        validateTab1: true,
      });
    },
    onChangeInitialEvaluationFlag() {
      this.$store.dispatch('ChangeInitialEvaluationAction');
    },
    goToAddAppointment() {
      const goToSection = 1;
      const goToUrl = `/student/registrygeneral?section=${goToSection}`;

      this.$router.push(goToUrl);
    },
  },
  computed: {
    showReports() {
      if (this.page.tabIndex == 6) {
        switch (this.student.statusId) {
          case StudentStatuses.Elegible:
          case StudentStatuses.NoElegible:
          case StudentStatuses.Servido:
          case StudentStatuses.Egreso:
            return true;
          default:
            return false;
        }
      }
      return false;
    },
    canCreateReferral() {
      return (
        this.page.tabIndex == 5 &&
        !this.student.isPostRegistry &&
        this.$store.getters.HasPermission('student.register.createreferral') &&
        this.showCreateNewReferralOption
      );
    },
    canSave() {
      return this.buttonsave;
    },
    canChangeInitialEvaluationFlag() {
      let isPostRegistry = this.$store.getters[
        '$_student/getStudentPreRegistry'
      ].isPostRegistry;
      if (
        this.studentStatus == 'Registro' &&
        this.$store.getters.HasPermission('registry.changeevaluationanswer') &&
        isPostRegistry &&
        (this.page.tabIndex == 6 || this.page.tabIndex == 5)
      ) {
        return true;
      } else {
        return false;
      }
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    isPreRegistred() {
      return this.studentStatus === 'Pre-Registro';
    },
    currentSection() {
      return Number(this.$route.query.section) || 1;
    },
    isInCoordinatedAppointment() {
      return (
        this.currentSection === 3 &&
        (this.studentStatus == 'Registro' || this.studentStatus == 'Evaluado')
      );
    },
    canEditPersonContactInformation() {
      return store.getters.HasPermission(
        'academic.registry.edit.personcontactinformation'
      );
    },
    canEditAddresses() {
      return store.getters.HasPermission('academic.registry.can.edit.address');
    },
    saveButtonVisibility() {
      if (
        this.canEditPersonContactInformation &&
        ['Registro', 'Evaluado', 'Elegible', 'Servido'].includes(
          this.studentStatus
        )
      ) {
        return false;
      } else if (
        this.canEditAddresses &&
        ['Elegible', 'Servido'].includes(this.studentStatus)
      ) {
        return false;
      } else if (
        this.studentStatus == 'No Elegible' ||
        this.studentStatus == 'Egreso' ||
        this.studentStatus == 'Inactivo' ||
        this.studentStatus == 'Servido'
      ) {
        return true;
      } else if (this.studentStatus == 'Disponible') {
        return false;
      } else if (this.page.tabIndex === 3 && this.studentStatus == 'Registro') {
        return false;
      } else if (
        (this.page.tabIndex === 1 ||
          this.page.tabIndex === 2 ||
          this.page.tabIndex === 3 ||
          this.page.tabIndex === 4) &&
        !this.isPreRegistred
      ) {
        return true;
      } else if (this.page.tabIndex === 5 && this.studentStatus == 'Elegible') {
        return true;
      } else {
        return false;
      }
    },
    studentPreRegistry() {
      return this.$store.getters['$_student/getStudentPreRegistry'];
    },
  },
};
</script>
